module.exports = __webpack_public_path__ + "static/media/default-profile.89ca4727.png";